module.exports = __webpack_public_path__ + "static/media/logo.2986eb3d.png";